var _style, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag11Sv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0B5089;}\n\t.st1{fill:#FFC100;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    className: "st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8C2.6,42,0,39.4,0,36.3V5.7 C0,2.6,2.6,0,5.8,0z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.9,16.4 25.9,0 16.7,0 16.7,16.4 0,16.4 0,25.6 16.7,25.6 16.7,42 25.9,42 25.9,25.6 64,25.6  64,16.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag11Sv);
export default __webpack_public_path__ + "static/media/flag_11_SV.421e1d090b19c00b79bd2fd222ad3d93.svg";
export { ForwardRef as ReactComponent };